import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Command } from './bridge-api-command-types';

/**
 * Create a command with a stable reference sustained across JavaScript contexts.
 * @example
 * ```typescript
 * const MyCommand = createCommand('my-command');
 * ```
 *
 * @param commandName a bundle-safe identifier which can be safely used within the same JavaScript context,
 * or across multiple JavaScript contexts. Especially important to avoid (1) clashing of identifiers in the
 * same bundle / JavaScript context, and (2) stability of identifiers across multiple JavaScript contexts.
 *
 * @returns a unique class instance representing this command.
 */
export function createCommand(commandName) {
  var _NamedCommand;
  return _NamedCommand = /*#__PURE__*/function (_Command) {
    function NamedCommand() {
      _classCallCheck(this, NamedCommand);
      return _callSuper(this, NamedCommand, arguments);
    }
    _inherits(NamedCommand, _Command);
    return _createClass(NamedCommand);
  }(Command), _defineProperty(_NamedCommand, "identifier", commandName), _NamedCommand;
}

/**
 * Create a broadcastable command with a stable identifier.
 */
export function createBroadcastableCommand(commandName) {
  var _NamedBroadcastCommand;
  // We create a class and then assert the broadcastable marker.
  return _NamedBroadcastCommand = /*#__PURE__*/function (_Command2) {
    function NamedBroadcastCommand() {
      _classCallCheck(this, NamedBroadcastCommand);
      return _callSuper(this, NamedBroadcastCommand, arguments);
    }
    _inherits(NamedBroadcastCommand, _Command2);
    return _createClass(NamedBroadcastCommand);
  }(Command), _defineProperty(_NamedBroadcastCommand, "identifier", commandName), _defineProperty(_NamedBroadcastCommand, "__broadcastable", true), _NamedBroadcastCommand;
}